import React from "react";
import { Phone, MessageCircle, Mail, Instagram as IgIcon } from "lucide-react";
import {
  ASSETS,
  PHONE_TEL,
  PHONE_DISPLAY,
  WHATSAPP_URL,
  EMAIL,
  INSTAGRAM_URL,
} from "../data/site";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative bg-[#050505] border-t border-white/10 overflow-hidden"
  >
    {/* Massive background lettering */}
    <div className="pointer-events-none select-none absolute -bottom-2 left-0 right-0 flex justify-center overflow-hidden">
      <span className="font-display font-bold uppercase text-[18vw] leading-none text-white/[0.04] whitespace-nowrap">
        FS GUINCHOS
      </span>
    </div>

    <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-10 pt-16 pb-10">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <img
            src={ASSETS.logo}
            alt="FS Guinchos"
            className="h-16 w-auto drop-shadow-[0_0_12px_rgba(230,0,0,0.35)]"
          />
          <p className="mt-4 text-neutral-400 text-sm max-w-xs leading-relaxed">
            Guincho 24 Horas em Porto Alegre e Região Metropolitana. Rapidez,
            confiança e segurança.
          </p>
          <div className="flex gap-3 mt-5">
            <a
              data-testid="footer-instagram"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-white/15 text-white hover:border-[#e60000] hover:text-[#e60000] transition-colors"
            >
              <IgIcon size={18} />
            </a>
            <a
              data-testid="footer-whatsapp"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-white/15 text-white hover:border-[#25D366] hover:text-[#25D366] transition-colors"
            >
              <MessageCircle size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white uppercase tracking-wide text-sm mb-4">
            Contato
          </h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                data-testid="footer-phone"
                href={PHONE_TEL}
                className="flex items-center gap-3 text-neutral-300 hover:text-white transition-colors"
              >
                <Phone size={16} className="text-[#e60000]" /> {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-neutral-300 hover:text-white transition-colors"
              >
                <MessageCircle size={16} className="text-[#25D366]" /> {PHONE_DISPLAY}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-email"
                href={`mailto:${EMAIL}`}
                className="flex items-center gap-3 text-neutral-300 hover:text-white transition-colors"
              >
                <Mail size={16} className="text-[#e60000]" /> {EMAIL}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white uppercase tracking-wide text-sm mb-4">
            Atendimento
          </h4>
          <p className="text-neutral-400 text-sm leading-relaxed">
            Porto Alegre • Gravataí • Cachoeirinha • Alvorada • Viamão • Canoas •
            Região Metropolitana • Outras cidades e estados.
          </p>
          <span className="inline-block mt-4 bg-[#e60000] text-white font-mono-tech text-xs tracking-widest px-3 py-1.5 uppercase">
            24 Horas por dia
          </span>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-neutral-500 text-xs">
          © {new Date().getFullYear()} FS Guinchos. Todos os direitos reservados.
        </p>
        <p className="text-neutral-600 text-xs font-mono-tech tracking-wide">
          Guincho • Reboque • Socorro Veicular • Porto Alegre / RS
        </p>
      </div>
    </div>
  </footer>
);
